import React from 'react';
import { saveAs } from 'file-saver';

import { pdf, PDFViewer } from '@react-pdf/renderer';
import { Button, Dialog, DialogContent } from '@material-ui/core';
import { PurchaseOrderFormValues } from 'src/redux/slices/purchase-order/types';
import PurchaseOrderPDFDocument from './dialog/PurchaseOrderPDFDocument';
import { useBranchInfo } from 'src/hooks/branch/use-branch-info';

interface Props {
  purchaseOrderData: PurchaseOrderFormValues;
  isPdfDialogVisible: boolean;
  onClose: () => void;
}

/**
 * NOTE: TALAGANG MAY MALAKING SPACING YUNG PDF KAPAG NAG PRINT. PARA PAG NAGMAXIMUM YUNG LINES NG PRODUCTS. KASYA PARIN!!!
 */

const PurchaseOrderPDF = ({
  isPdfDialogVisible,
  onClose,
  purchaseOrderData = {}
}: Props) => {
  const { branchPONickNameViaID } = useBranchInfo();

  const onDownloadPurchaseOrder = async () => {
    const branchName = branchPONickNameViaID(purchaseOrderData?.branch_id || 0); // 0 is impossible
    const fileName = `${branchName} ${purchaseOrderData.order_no}.pdf`;
    const blob = await pdf(
      <PurchaseOrderPDFDocument purchaseOrderData={purchaseOrderData} />
    ).toBlob();
    saveAs(blob, fileName);
  };

  return (
    <Dialog
      fullWidth
      maxWidth={'xl'}
      open={isPdfDialogVisible}
      onClose={onClose}
    >
      <DialogContent>
        <Button
          variant="contained"
          color="primary"
          onClick={onDownloadPurchaseOrder}
        >
          Download
        </Button>
        <PDFViewer
          width="100%"
          height="100%"
          style={{ height: '80vh', width: '100%' }}
        >
          <PurchaseOrderPDFDocument purchaseOrderData={purchaseOrderData} />
        </PDFViewer>
      </DialogContent>
    </Dialog>
  );
};

export default PurchaseOrderPDF;
